import React, { createContext, useContext, useEffect, useReducer, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { UserInfoContext } from './UserInfoProvider'
import * as apiStatusCodes from '../../constants/apiStatusCodes'
import { getQueryState, handleErrors } from '../services/apiUserService'
import {
  UserConfigInitialStateForm,
  UserInfoInitialStateForm
} from '../helpers/formControlsVariables'
import { handleTabClick, handleUpdate } from '../helpers/UserConfigHandlers'
import validate from '../../helpers/validation'

const initialState = {}

const UserConfigContext = createContext(initialState)

// Contexto parcialmente legacy: edición de flags AVE (UserConfigDetailTab) ya no está en el UI.
// TabsUserConfig solo usa handleTabClickConfig / isEditingUserConfigTab. Limpiar al borrar UserConfigDetailTab.
const UserConfigProvider = (props) => {
  const navigate = useNavigate()
  const { uid } = useParams()
  const { fetchUserInfo } = useContext(UserInfoContext)
  const [isFetching, setFetching] = useState(true)
  const [isEditingUserConfigTab, setEditing] = useState(false)
  const [businessData, setBusinessData] = useState({})
  const [title, setTitle] = useState('')
  const [failedCreationState, setFailedCreationState] = useState(false)
  const [failedCreationInfo, setFailedCreationInfo] = useState(null)
  const [activeTab, setActiveTab] = useState('Detalles')
  const [formIsValid, setFormIsValid] = useState(true)
  const [formControls, setFormControls] = useState(UserConfigInitialStateForm)

  const formSubmitUpdate = (event) => {
    event.preventDefault()
    // Legacy: UserConfigDetailTab no montado; flags vía ubiqua_app_users, no /admin/salesmen.
  }

  const changeHandler = (event) => {
    const name = event.target.name
    const value = event.target.value

    const updatedControls = {
      ...formControls
    }
    const updatedFormElement = {
      ...updatedControls[name]
    }

    updatedFormElement.value = value
    updatedFormElement.touched = true
    updatedFormElement.valid = validate(value, updatedFormElement.validationRules)

    updatedControls[name] = updatedFormElement

    let formIsValid = true
    for (const inputIdentifier in updatedControls) {
      formIsValid = updatedControls[inputIdentifier].valid && formIsValid
    }

    setFormControls(updatedControls)
    setFormIsValid(formIsValid)
  }

  const handleUpdateConfigFlags = (event, userInfo) => {
    setFormControls({
      ...formControls,
      can_access_refunds_app: {
        ...formControls.can_access_refunds_app,
        value: userInfo.can_access_refunds_app
      },
      can_change_prices: {
        ...formControls.can_change_prices,
        value: userInfo.can_change_prices
      },
      can_set_prices_on_quote_items: {
        ...formControls.can_set_prices_on_quote_items,
        value: userInfo.can_set_prices_on_quote_items
      },
      has_fixed_route: {
        ...formControls.has_fixed_route,
        value: userInfo.has_fixed_route
      },
      can_consolidate_orders: {
        ...formControls.can_consolidate_orders,
        value: userInfo.can_consolidate_orders
      },
      can_see_customer_segment: {
        ...formControls.can_see_customer_segment,
        value: userInfo.can_see_customer_segment
      },
      enable_fiscal_printer: {
        ...formControls.enable_fiscal_printer,
        value: userInfo.enable_fiscal_printer
      },
      can_select_discount: {
        ...formControls.can_select_discount,
        value: userInfo.can_select_discount
      },
      route: {
        ...formControls.route,
        value: userInfo.route
      },
      active: {
        ...formControls.active,
        value: userInfo.active
      },
      mobile: {
        ...formControls.mobile,
        value: userInfo.mobile ? userInfo.mobile : ''
      },
      email: {
        ...formControls.email,
        value: userInfo.salesman_email ? userInfo.salesman_email : ''
      },
      code: {
        ...formControls.code,
        value: userInfo.db_ref
      },
      name: {
        ...formControls.name,
        value: userInfo.name
      }
    })
    const value = handleUpdate(event)
    setEditing(value)
  }

  const handleCancelConfigFlags = (event) => {
    const value = handleUpdate(event)
    setEditing(value)
  }

  const handleTabClickConfig = (event) => {
    const value = handleTabClick(event, isEditingUserConfigTab)
    setActiveTab(value.activeTab)
    setEditing(value.editing)
  }

  const hideFailedCreationMessage = () => {
    setFailedCreationInfo(null)
  }

  const evaluateResponse = (obj, userUid) => {
    switch (obj.status) {
      case 422:
        setFailedCreationInfo('Verifique la informacion ingresada.')
        setTimeout(hideFailedCreationMessage, 9000)
        break
      case 409:
        setFailedCreationInfo(
          'Error al guardar cambios. El código ingresado ya existe. Por favor escoger otro código.'
        )
        setTimeout(hideFailedCreationMessage, 9000)
        break
      case 404:
        setFailedCreationInfo('Servidor fuera de servicio')
        setTimeout(hideFailedCreationMessage, 9000)
        break
      case 500:
        setFailedCreationInfo('Error interno en el sistema')

        setTimeout(hideFailedCreationMessage, 9000)
        break
      default:
        setEditing(false)
        if (userUid === uid) {
          fetchUserInfo(uid)
        }
        navigate(`/usuarios/${encodeURIComponent(userUid)}`, { replace: true })
        break
    }
  }

  return (
    <UserConfigContext.Provider
      value={{
        isFetching,
        businessData,
        title,
        isEditingUserConfigTab,
        activeTab,
        formControl: formControls,
        failedCreationInfo,
        handleUpdateConfigFlags,
        handleTabClickConfig,
        changeHandler,
        formSubmitUpdate,
        handleCancelConfigFlags
      }}
    >
      {props.children}
    </UserConfigContext.Provider>
  )
}
export { UserConfigContext, UserConfigProvider }
